import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import events from '../../events';
import { HistoryType } from '../../types/router';
import actions from '../../state/actions';
import { REDIRECT_NOTIFICATION } from '../../state/types';

class PushNotificationHandler extends React.Component {
  constructor(props) {
    super(props);

    this.handler = ({ message }) => this.handleNotification(message);
  }

  componentWillMount() {
    events.on('messages.notification', this.handler);
  }

  componentWillUnmount() {
    events.off('messages.notification', this.handler);
  }

  handleNotification(msg) {
    const {
      dispatch,
      history,
    } = this.props;

    const message = {
      ...msg,
      ..._.has(msg, 'data') && msg.data,
    };

    let url = null;
    if (_.has(message, 'service_request')) {  // GCM service request notification
      try {
        const serviceRequest = JSON.parse(message.service_request);
        url = `/access/requests/${serviceRequest.id}/details`;
      } catch (e) {
        console.error(e);
      }
    } else if (_.has(message, 'service_request_id')) {  // APNS service request notification
      url = `/access/requests/${message.service_request_id}/details`;
    } else if (_.has(message, 'work_order')) {  // GCM work order notification
      try {
        const workOrder = JSON.parse(message.work_order);
        url = `/access/workorders/${workOrder.id}/details`;
      } catch (e) {
        console.error(e);
      }
    } else if (_.has(message, 'work_order_id')) {  // APNS work order notification
      url = `/access/workorders/${message.work_order_id}/details`;
    }


    if (message.message) {
      if (!message.foreground) {
        // handling native push notification click from background
        history.push(url);
      } else {
        // show notification in foreground application
        dispatch(actions.showNotification(message.message, true, {
          actionPayload: {
            url,
          },
          action: REDIRECT_NOTIFICATION,
          actionLabel: 'View',
          location: 'top-center',
          type: 'primary',
          showClose: true,
          sound: 'notification',
        }));
      }
    }

    events.emit('notifications.content_available');
    // Refresh the tickets list on push notification
    dispatch(actions.refreshAction());
  }

  render() {
    return null;
  }
}

PushNotificationHandler.propTypes = {
  history: HistoryType,
  dispatch: PropTypes.func,
};

export default withRouter(connect()(PushNotificationHandler));



// WEBPACK FOOTER //
// ./src/app/components/PushNotificationHandler.js